<template>
  <div class="convention-hall page">
    <van-nav-bar class="nav-bar" :title="$t('选妃')" />
    <div class="convention-item">
      <van-tabs :swipeable="true" animated line-width="100px" sticky>
        <van-tab :title="$t('城市大全')">
          <div class="card">
            {{ noticeHeader.text }}
          </div>
          <div class="address">
            <template v-for="(list, index) in addlist">
              <van-row
                v-for="(val, key) in list"
                class="address-item"
                @click="addgo(val)"
                :key="index + '-' + key"
                gutter="65"
              >
                {{ val.name }}
                <!--<van-col v-for="(v, k) in val" :key="k" offset="" span="" @click="addgo(v)">{{ v.name }}</van-col>-->
              </van-row>
            </template>
          </div>
        </van-tab>
        <van-tab :title="$t('流程价格')">
          <div class="card">
            {{ noticeHeader.text }}
          </div>
          <div class="rig-box">
            <div v-for="notice in noticeList" :key="notice.id">
              <p class="rig-title">{{ notice.name }}</p>
              <p class="rig-content">{{ notice.text }}</p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addlist: [],
      noticeHeader: {},
      noticeList: []
    }
  },
  methods: {
    addgo(data) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '/list?id=' + data.id + '&name=' + data.name })
      }
    },
    getAddress() {
      this.$http({
        method: 'get',
        url: 'address_list'
      }).then((res) => {
        console.log('=>(index.vue:69) res.data', res.data)
        this.addlist = res.data
      })
    },
    getNoticeData() {
      const headerRequest = this.$http({
        method: 'get',
        url: 'sys_get_notice_list',
        data: { type: 3 }
      })

      const listRequest = this.$http({
        method: 'get',
        url: 'sys_get_notice_list',
        data: { type: 2 }
      })

      Promise.all([headerRequest, listRequest])
        .then(([headerRes, listRes]) => {
          this.noticeHeader = headerRes.data[0]
          this.noticeList = listRes.data
        })
        .catch((error) => {
          console.error('Error fetching notice data:', error)
        })
    }
  },
  created() {
    this.getAddress()
    this.getNoticeData()
  }
}
</script>

<style lang="less" scoped>
.convention-item {
  padding-bottom: 200px;
  background: #f2f2f5;
}
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.nav-bar {
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  height: 100px;
}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.van-sidebar {
  width: 180px;
}

.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: #f2f2f5;
}

::v-deep .van-tab {
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;
}

::v-deep .van-tabs__line {
  background-color: #7e5678;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

.card {
  background-color: #8a637d;
  padding: 0.625rem;
  width: 95%;
  color: white;
  font-size: 0.8125rem;
  margin: 0.625rem auto;
  border-radius: 0.375rem;
}

::v-deep .van-row--flex {
  height: 80px;
  line-height: 80px;
}

.rig-box {
  width: 95%;
  margin: 0.625rem auto;
}

.rig-title {
  color: #0bdab0;
  font-size: 1.125rem;
}

.rig-content {
  font-size: 20px;
  // margin-top: 10px;
}

.address {
  border-radius: 4px;
  background-color: #fff;
  margin: 0.325rem 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.address-item {
  border-bottom: 1px solid #eee;
  padding: 18px 35px;
}
.address-item:last-child {
  border-bottom: none;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  // Tab PC端适配
  ::v-deep .van-tab {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
    line-height: 57px; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-tabs--line .van-tabs__wrap {
    height: 57px; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-tabs__wrap--scrollable .van-tab {
    padding: 0 13px; /* 23px * 0.5733 ≈ 13px */
  }

  ::v-deep .van-tabs__line {
    width: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  // 内容区域PC端适配
  .convention-item {
    padding-bottom: 115px; /* 200px * 0.5733 ≈ 115px */
  }

  .card {
    padding: 10px; /* 0.625rem ≈ 10px (假设1rem=16px), 10px * 0.5733 ≈ 6px，但保持可读性 */
    width: 95%;
    font-size: 13px; /* 0.8125rem ≈ 13px (假设1rem=16px), 13px * 0.5733 ≈ 7px，但保持可读性 */
    margin: 10px auto; /* 0.625rem ≈ 10px */
    border-radius: 6px; /* 0.375rem ≈ 6px (假设1rem=16px) */
  }

  ::v-deep .van-row--flex {
    height: 46px; /* 80px * 0.5733 ≈ 46px */
    line-height: 46px; /* 80px * 0.5733 ≈ 46px */
    font-size: 15px; /* 假设26px * 0.5733 ≈ 15px */
  }

  .rig-box {
    width: 95%;
    margin: 10px auto; /* 0.625rem ≈ 10px */
  }

  .rig-title {
    font-size: 16px; /* 1.125rem ≈ 18px (假设1rem=16px), 18px * 0.5733 ≈ 10px，但保持可读性 */
  }

  .rig-content {
    font-size: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .address {
    border-radius: 2px; /* 4px * 0.5733 ≈ 2px */
    margin: 5px 11px; /* 0.325rem ≈ 5px (假设1rem=16px), 20px * 0.5733 ≈ 11px */
  }

  .address-item {
    padding: 10px 20px; /* 18px * 0.5733 ≈ 10px, 35px * 0.5733 ≈ 20px */
    font-size: 15px; /* 假设26px * 0.5733 ≈ 15px */
  }
}
</style>
